import { useState, useEffect } from 'react';
import { createClient } from 'contentful';

const client = createClient({
    environment: 'master', 
    space: process.env.GATSBY_CONTENTFUL_SPACE,
    accessToken: process.env.GATSBY_CONTENTFUL_ACCESS_TOKEN,
});

const useContentfulCalculators = (filter) => {
    const [calculators, setCalculators] = useState([]);

    useEffect(() => {
        client.getEntries({
            content_type: 'calculators',
            'fields.calculatorListedOn': 'Spain',
            ...filter
        })
        .then((response) => {
            setCalculators(response.items);
        })
        .catch(console.error);
    }, [filter]);

    return calculators;
};

export default useContentfulCalculators;
